import { render } from "./PlayerList.vue?vue&type=template&id=41a45bb8&scoped=true"
import script from "./PlayerList.vue?vue&type=script&lang=js"
export * from "./PlayerList.vue?vue&type=script&lang=js"

import "./PlayerList.vue?vue&type=style&index=0&id=41a45bb8&scoped=true&lang=css"
import "./PlayerList.vue?vue&type=style&index=1&id=41a45bb8&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a45bb8"]])

export default __exports__